/*
 * The corners' one layer (`CornersProvider`): the viewport less its inset,
 * a top band as tall as what is in it and a bottom band with the rest, two
 * stacks in each. Only the pieces take pointer events; the layer and its
 * boxes never do.
 */
.layer {
  --inset: 24px;
  position: fixed;
  inset: 0;
  /* Above the page's own layers (the sticky setup bar is 2147482500). */
  z-index: 2147483000;
  display: grid;
  grid-template-rows: minmax(0, auto) minmax(0, 1fr);
  gap: 8px;
  box-sizing: border-box;
  padding: max(var(--inset), env(safe-area-inset-top))
    max(var(--inset), env(safe-area-inset-right))
    max(var(--inset), env(safe-area-inset-bottom))
    max(var(--inset), env(safe-area-inset-left));
  pointer-events: none;
}

/* Left and right corners of one side; the right one wraps onto its own line
   (below the top, above the bottom) when the two would meet. */
.band {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  min-height: 0;
}

.band[data-band="bottom"] {
  flex-direction: row-reverse;
  flex-wrap: wrap-reverse;
  align-items: flex-end;
}

/* A corner: its pieces from the edge in, 8px apart, as tall as its band at most. */
.stack {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  min-height: 0;
  max-height: 100%;
}

.stack[data-corner^="bottom"] {
  flex-direction: column-reverse;
}

/* Each stack keeps its own side even when it is alone in its band or wraps onto its own line
   (space-between puts a lone stack at the band's start: a top-right piece drew at the top-left). */
.stack[data-corner$="left"] {
  align-items: flex-start;
  margin-right: auto;
}

.stack[data-corner$="right"] {
  align-items: flex-end;
  margin-left: auto;
}

.stack:not(:has(> .item:not(:empty))) {
  display: none;
}

.item {
  display: flex;
  flex: none;
  flex-direction: column;
  min-height: 0;
  max-height: 100%;
}

/* A piece that fits itself to the room its corner has left (the cogent's chat scrolls). */
.item:has(> [data-corner-fit]) {
  flex-shrink: 1;
}

.item:empty {
  display: none;
}

.stack[data-corner$="right"] > .item {
  align-items: flex-end;
}

@media (max-width: 640px) {
  .layer {
    --inset: 16px;
  }
}

/* Keep corner controls below the fixed site header. */
:global(body):has(:global([data-site-header])) .layer {
  padding-top: calc(65px + 8px);
}

:global(body):has(:global([data-league-bar])) .layer {
  padding-top: calc(65px + 32px + 8px);
}
